/**
 * @file automatically generated from MApp.Endpoints.AppController
 */ 

import { MetadataClient } from '../metadataClient';
import { IMApp } from '../models';

export class AppClient extends MetadataClient {

    public static getMApps() {
        return MetadataClient.ajax<IMApp[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/apps/mapps`)
        );
    }
}
